import { createFileRoute } from '@tanstack/react-router';
import { InventoryDashboard } from '@/features/inventory/InventoryDashboard';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/overview')({
  component: InventoryDashboard,
});
